// extracted by mini-css-extract-plugin
module.exports = {"AccountOrders":"styles_AccountOrders__YYKYm","AccountOrders__loadMore":"styles_AccountOrders__loadMore__UEvkO"};